import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-floating-shapes',
    imports: [],
    templateUrl: './floating-shapes.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './floating-shapes.component.scss'
})
export class FloatingShapesComponent {

}
